import PhoneConfirm from "./PhoneConfirm";
import "./style.css";
export default PhoneConfirm;
